<template>
  <div>
    <div class="hero">
      <slot name="hero"></slot>
    </div>
    <div class="form-section">
      <slot name="form-section"></slot>
    </div>
    <div>
      <slot name="first-row"></slot>
    </div>
    <div>
      <slot name="second-row"></slot>
    </div>
    <div>
      <slot name="third-row"></slot>
    </div>
    <div>
      <slot name="fourth-row"></slot>
    </div>
    <div>
      <slot name="fifth-row"></slot>
    </div>
    <div class="google-reviews">
      <slot name="google-reviews"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.google-reviews {
  width: 100%;
  padding: 40px 10px;
}
</style>



// WEBPACK FOOTER //
// IndustrySingle.vue?327075e6